import { createSlice } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const initialState = {
  data: null,
};

const apiUrl = process.env.REACT_APP_MIDDLEWARE_URL;

export const redevanceSlice = createSlice({
  name: "redevance",
  initialState,
  reducers: {
    setRedevance: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.data = state.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setRedevable } = redevanceSlice.actions;

export default redevanceSlice.reducer;

export const redevanceApi = createApi({
  reducerPath: "redevanceApi",
  baseQuery: fetchBaseQuery({
    baseUrl: apiUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = JSON.parse(localStorage.getItem('auth'))?.jwt;

      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      headers.set('Content-type', 'application/json')
      headers.set('Accept', 'application/json')
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getRedevance: builder.query({
      query: ({ page, size }) => `/redevances?pagination[page]=${page}&pagination[pageSize]=${size}&sort=id:desc`,
    }),
    getRedevanceById: builder.query({
      query: (id) => `/redevances/${id}`,
    }),
    searchRedevancesByRedevableName: builder.query({
      query: ({ name, page, size }) => `/redevances?filters[redevable][name][$contains]=${name}&pagination[page]=${page}&pagination[pageSize]=${size}&sort=id:desc`,
    }),

    getRedevanceAnalyseById: builder.query({
      query: (id) => `/redevances/analyse/${id}`,
    }),
    postRedevance: builder.mutation({
      query: (data) => ({
        url: `/redevances`,
        method: "POST",
        body: data,
      }),


    }),
    updateRedevance: builder.mutation({
      query: ({ id, data }) => ({
        url: `/redevances/${id}`,
        method: "PUT",
        body: data,
      }),
    }),


  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetRedevanceQuery, usePostRedevanceMutation, useLazyGetRedevanceByIdQuery, useLazyGetRedevanceAnalyseByIdQuery, useUpdateRedevanceMutation, useLazyGetRedevanceQuery, useLazySearchRedevancesByRedevableNameQuery } = redevanceApi;
